;(function () {
  'use strict'
  angular
    .module('contrast.freemium')
    .factory(
      'freemiumService',
      function freemiumServiceFactory(freemiumApiConfig, ServiceUtils) {
        'ngInject'

        return {
          getPreference: getPreference
        }

        function getPreference(name) {
          return freemiumApiConfig
            .getPreference(name)
            .then(ServiceUtils.handleResolve('data'))
            .catch(ServiceUtils.handleError)
        }
      }
    )
})()
